import mobileMoney from "../assets/images/cashoutLogo.svg";
import card from "../assets/images/creditCardLogo.svg";
import paypal from "../assets/images/payPalLogo.svg";

export const logoNameToPath: { [key: string]: string } = {
  Paypal: paypal,
  Card: card,
  "Mobile Money": mobileMoney,
};
